import {API_ACTION, API_EMPLOYEE, API_EMPLOYEE_COMPLETE} from "../../const/Api";
import {RestApiMethod} from "../../const/dataEnum";
import {callAPI} from "./callApi";

const getEmployee = async (params) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_EMPLOYEE,
      params,
    });
    return res.data;
  } catch (error) {
    console.error('employeeApi getEmployee Error:', error.message);
    return null;
  }
};

const getCompleteEmployee = async (params) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_EMPLOYEE_COMPLETE,
      params: params
    })
    return res.data;
  } catch (error) {
    console.error('employeeApi getCompleteEmployee Error:', error.message);
    return null;
  }
}

const getEmployeeByDepartementId = async (params) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_EMPLOYEE + `/department/${params}`
    });
    return res.data;
  } catch (error) {
    console.error('employeeApi getEmployeeByDepartementId Error:', error.message);
    return null;
  }
};

const addEmployee = async (employee) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_EMPLOYEE + API_ACTION.CREATE,
      data: employee,
    });
    return res.data;
  } catch (error) {
    console.error('employeeApi addEmployee Error:', error.message);
    return null;
  }
};

const updateEmployee = async (data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_EMPLOYEE + API_ACTION.UPDATE,
      data,
    });
    return res.data;
  } catch (error) {
    console.error('employeeApi updateEmployee Error:', error.message);
    return null;
  }
};

const deleteEmployee = async (data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_EMPLOYEE + API_ACTION.DELETE,
      data,
    });
    return res.data;
  } catch (error) {
    console.error('employeeApi deleteEmployee Error:', error.message);
    return null;
  }
}

const employeeApi = {
  getEmployee,
  getCompleteEmployee,
  getEmployeeByDepartementId,
  addEmployee,
  updateEmployee,
  deleteEmployee,
}

export default employeeApi;